// src/pages/BulkUpdateCalender.jsx
import React, { useEffect, useState } from "react";
import Hearder from "../../commun/Hearder";
import SideBar from "../../commun/SideBar";
import { useNavigate } from "react-router-dom";
import { roomlistdetail } from "../../../Services/Service";

export const BulkUpdateCalender = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [room , setRoom] = useState ([]);
    const [rooms, setRooms] = useState([
        {
            id: 1,
            title: "Deluxe Twin Room",
            subTitle: "Deluxe Twin Room",
            prices: ["2500", "2500", "4000", "4450", "4450", "0", "0", "2400", "2500"],
            available: [2, 9, 7, 1, 0, 0, 0, 2, 3],
        },
        {
            id: 2,
            title: "Deluxe King Room",
            subTitle: "Deluxe King Room",
            prices: ["2500", "2500", "4000", "4450", "4450", "0", "0", "1800", "2000"],
            available: [4, 7, 8, 7, 0, 0, 0, 4, 5],
        },
    ]);

    // Number of days to show at once (9 as requested)
    const DEFAULT_DAYS = 9;

    // State for dates and the current "start" date
    const [dates, setDates] = useState([]);
    const [startDate, setStartDate] = useState(null);

    // Helpers
    const formatShortWeekday = (d) =>
        d.toLocaleString("en-US", { weekday: "short" }).toUpperCase();
    const formatShortMonth = (d) =>
        d.toLocaleString("en-US", { month: "short" }).toUpperCase();
    const formatLegendDate = (d) =>
        `${d.getDate()} ${d.toLocaleString("en-US", { month: "short" })} ${d.getFullYear()}`;

    // Generate N days starting from `start` (inclusive)
    const generateDates = (start, n = DEFAULT_DAYS) => {
        const arr = [];
        for (let i = 0; i < n; i++) {
            const dd = new Date(start);
            dd.setDate(start.getDate() + i);
            arr.push({
                dateObj: dd,
                short: formatShortWeekday(dd),
                day: dd.getDate(),
                mon: formatShortMonth(dd),
            });
        }
        setDates(arr);
        setStartDate(new Date(start)); // keep a copied Date object
    };

    // Initial dates on component mount (start from current date)
    useEffect(() => {
        const initial = new Date(); // today
        initial.setHours(0, 0, 0, 0);
        generateDates(initial, DEFAULT_DAYS);
    }, []);

    // Next N days
    const handleNext = () => {
        if (!startDate) return;
        const nextStart = new Date(startDate);
        nextStart.setDate(startDate.getDate() + DEFAULT_DAYS);
        generateDates(nextStart, DEFAULT_DAYS);
    };

    // Prev: directly show previous DEFAULT_DAYS (no prompt)
    const handlePrev = () => {
        if (!startDate) return;
        const prevStart = new Date(startDate);
        prevStart.setDate(startDate.getDate() - DEFAULT_DAYS);
        generateDates(prevStart, DEFAULT_DAYS);
    };

    // Legend text: show start - end or single date if only one
    const legendText = dates.length
        ? `${formatLegendDate(dates[0].dateObj)}${dates.length > 1 ? " — " + formatLegendDate(dates[dates.length - 1].dateObj) : ""}`
        : "";


    useEffect(() => {
        setLoading(true);
        const fetchRoomData = async () => {
            try {
                const data = await roomlistdetail();
                if (Array.isArray(data)) setRoom(data);

            } catch (error) {
                console.error("Room data fetch error:", error);
            }
            finally {
                setLoading(false);
            }
        };
        fetchRoomData();
    }, [])



    return (
        <>
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card mt-3">
                                        <div className="card-body">
                                            <h4 className="card-title mb-2">CALENDER</h4>
                                            {/* Calendar header (dates) */}
                                            <div className="calendar-header overflow-auto mb-2">
                                                <div className="d-flex align-items-center" style={{ position: "relative" }}>
                                                    <div className="legend-box" style={{ width: "300px", justifyItems: "center" }}>
                                                        <div className="fw-bold" style={{ fontSize: "17px" }}>{legendText}</div>
                                                    </div>

                                                    {/* LEFT / PREV BUTTON */}
                                                    <div className="position-relative">
                                                        <button
                                                            onClick={handlePrev}
                                                            aria-label="Show previous dates"
                                                            className="btn btn-sm d-flex justify-content-center align-items-center"
                                                            style={{
                                                                backgroundColor: "white",
                                                                borderRadius: "50%",
                                                                width: "35px",
                                                                height: "35px",
                                                                border: "1px solid #ddd",
                                                                position: "absolute",
                                                                top: "-16px",
                                                                right: "-17px"
                                                            }}
                                                        >
                                                            <i className="fas fa-chevron-left" style={{ fontSize: "15px" }}></i>
                                                        </button>
                                                    </div>

                                                    {/* Dates */}
                                                    {dates.map((d, i) => (
                                                        <div key={i} className="date-cell text-center">
                                                            <div className="fw-bold small">{d.short}</div>
                                                            <div className="h5 mb-0">{d.day}</div>
                                                            <div className="small text-muted">{d.mon}</div>
                                                        </div>
                                                    ))}

                                                    {/* RIGHT / NEXT BUTTON */}
                                                    <div className="position-relative">
                                                        <button
                                                            onClick={handleNext}
                                                            aria-label="Show next dates"
                                                            className="btn btn-sm d-flex justify-content-center align-items-center"
                                                            style={{
                                                                backgroundColor: "white",
                                                                borderRadius: "50%",
                                                                width: "35px",
                                                                height: "35px",
                                                                border: "1px solid #ddd",
                                                                position: "absolute",
                                                                top: "-16px",
                                                                right: "-17px"
                                                            }}
                                                        >
                                                            <i className="fas fa-chevron-right" style={{ fontSize: "15px" }}></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex" style={{ gap: "13px", borderBottom: "1px solid #e9ecef" }}>
                                                <div className="col-md-2 mb-2">
                                                    <select className=" form-select">
                                                        <option>Base Rate</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select className="form-select">
                                                        <option value="">Select Rooms</option>

                                                        {room.map((room) => (
                                                            <option key={room.RoomID} value={room.RoomID}>
                                                                {room.RoomName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                            </div>

                                            {/* Rooms list */}
                                            <div className="rooms-section">
                                                {rooms.map((room) => (
                                                    <div key={room.id} className="room-row ">
                                                        <div >
                                                            <div className="d-flex align-items-start">
                                                                <div className="room-info me-3" style={{ minWidth: 285 }}>
                                                                    <div className="d-flex align-items-center mb-1">
                                                                        <div>
                                                                            <div className="fw-bold">{room.title}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div className="dates-row overflow-auto flex-grow-1">
                                                                    <div className="d-flex">
                                                                        {room.prices.map((price, idx) => {

                                                                            const isZeroAvail = room.available[idx] === 0;

                                                                            return (
                                                                                <div key={idx} className="date-box text-center">


                                                                                    <div
                                                                                        className="avail small mb-1"
                                                                                        style={{
                                                                                            color: isZeroAvail ? "black" : "#6c757d",
                                                                                            backgroundColor: isZeroAvail ? "#ffe5e5" : "transparent",
                                                                                            border: isZeroAvail ? "1px solid red" : "1px solid transparent",
                                                                                            borderRadius: "4px",
                                                                                            padding: "2px 4px"
                                                                                        }}
                                                                                    >
                                                                                        {room.available[idx]}
                                                                                    </div>

                                                                                    <input
                                                                                        className="form-control form-control-sm price-input"
                                                                                        value={price}

                                                                                        style={{ cursor: "pointer" }}
                                                                                        onMouseDown={(e) => {
                                                                                            e.preventDefault(); // focus remove, typing block
                                                                                            navigate("/Property/BulkUpdateRate"); // ✔ correct navigate
                                                                                        }}
                                                                                    />


                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                        </div> {/* card-body */}
                                    </div> {/* card */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Inline custom styles for the calendar UI */}
            <style jsx="true">{`
        .calendar-header { border-bottom: 1px solid #e9ecef; padding: 0px !important; }
        .date-cell { width: 88px; min-width: 88px; padding: 6px 10px; border-radius: 0px; background: #f8f9fa; border-right: 1px dotted #726e6e45;}
        .room-row { border: 1px solid #eef0f2; border-radius: 6px; padding-bottom: 0px ;}
        .room-info { border-right: 1px dashed #e9ecef; padding-right: 16px;  margin-top: 25px; justify-items: center;}
        .dates-row { padding-left: 0px; padding-right: 8px; }
        .date-box {  width: 88px; min-width: 88px; padding: 6px 10px; border-radius: 0px; border-right: 1px solid #e9ecef;}
        .price-input { text-align: center; }
        .price-input.is-zero { background: #ffecec; border-color: #ffb3b3; }
        .avail { font-weight: 600; color: #6c757d; }
        .date-box .badge.bg-danger { font-size: 0.7rem; padding: 0.25rem 0.4rem; }
        .legend-square { display:inline-block; width:14px; height:10px; border-radius:3px; margin-right:6px; vertical-align:middle;}
        .stop-sell { background:#f4c2c2; border:1px solid #e8a6a6; }
        .min-stay { background:#ffe6a7; border:1px solid #f1d092; }
        .close-dep { background:#dbe9ff; border:1px solid #b6d2ff; }
        .close-arr { background:#e8f7e8; border:1px solid #cfeccf; }
        .no-avail { background:#ffd6d6; border:1px solid #ffbcbc; }
        /* make inner rows horizontally scrollable nicely */
        .calendar-header .d-flex, .dates-row .d-flex { gap: 12px; }
        /* small screens */
        @media (max-width: 768px) {
          .room-info { min-width: 200px; }
          .date-box { min-width: 90px; }
          .date-cell { min-width: 72px; }
        }
        
    .calendar-header .d-flex, .dates-row .d-flex {
     gap: 0px !important; 
}
      `}</style>
        </>
    );
};

export default BulkUpdateCalender;
